import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const UnorderedList = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M6.985 13C5.91 13 5 12.09 5 10.985 5 9.91 5.91 9 7.015 9 8.09 9 9 9.91 9 11.015 9 12.09 8.09 13 6.985 13m34.017 0H14.998A2.011 2.011 0 0 1 13 10.985C13 9.91 13.894 9 14.998 9h26.004C42.106 9 43 9.91 43 11.015A2.005 2.005 0 0 1 41.002 13M6.985 26C5.91 26 5 25.09 5 23.985 5 22.91 5.91 22 7.015 22 8.09 22 9 22.91 9 24.015 9 25.09 8.09 26 6.985 26m34.017 0H14.998A2.011 2.011 0 0 1 13 23.985C13 22.91 13.894 22 14.998 22h26.004c1.104 0 1.998.91 1.998 2.015A2.005 2.005 0 0 1 41.002 26M6.985 39C5.91 39 5 38.09 5 36.985 5 35.91 5.91 35 7.015 35 8.09 35 9 35.91 9 37.015 9 38.09 8.09 39 6.985 39m34.017 0H14.998A2.011 2.011 0 0 1 13 36.985C13 35.91 13.894 35 14.998 35h26.004c1.104 0 1.998.91 1.998 2.015A2.005 2.005 0 0 1 41.002 39"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
